<router>
  {
    name: 'userAsOthersSee'
  }
</router>
<script>
  import Component from '../index/index.vue';

  export default Component;
</script>
